module.exports = __webpack_public_path__ + "static/img/auth_card_up.11b2eaef.png";